import { BankxDashboardLayout } from 'components/layouts/BankxDashboardLayout';
import { NftLeaderboard } from 'components/NftLeaderboard';
import React from 'react';

export function NFTLeaderboardPage() {
    return (
        <BankxDashboardLayout>
            <link rel='stylesheet' href='/css/landing.css' />
            <NftLeaderboard />
        </BankxDashboardLayout>
    );
}
